import Analytics from "@/shared/utils/tagManagerAnalytics";
import { DndContext } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";
import { useSortableList } from "@shared/hooks/useSortable";
import { useContactActions } from "@survey-cover/contacts/hooks/useContactActions";
import type {
  ExtendedSurveyContact,
  SurveyContact,
} from "@survey-types/survey.contacts.types";
import { SortableContactRow } from "./SortableContactRow";

export type {
  ExtendedSurveyContact,
  SortableContactListProps,
  SurveyContact,
} from "@survey-types/survey.contacts.types";

const SortableContactList = ({
  contacts,
}: {
  readonly contacts: readonly SurveyContact[];
}) => {
  const { handleReorderContacts } = useContactActions();

  const contactsWithId: ExtendedSurveyContact[] = contacts.map(
    (contact, index) => ({
      ...contact,
      id: contact.contactId ?? contact.email ?? `contact-${index}`,
    }),
  );

  const handleReorder = (
    reorderedContacts: ExtendedSurveyContact[],
    oldIndex: number,
    newIndex: number,
  ) => {
    Analytics.send({
      DragHandleEntity: "Individual Contact",
    });

    const cleanedContacts = reorderedContacts.map(({ id, ...cleanContact }) => {
      void id;
      return cleanContact as SurveyContact;
    });
    handleReorderContacts(cleanedContacts, oldIndex, newIndex);
  };

  const { DndContextProps, SortableContextProps, orderedItems } =
    useSortableList({
      items: contactsWithId,
      onReorder: handleReorder,
      idField: "id",
    });

  return (
    <DndContext {...DndContextProps}>
      <SortableContext {...SortableContextProps}>
        {orderedItems.map((contact) => (
          <SortableContactRow
            key={contact.id}
            id={String(contact.id)}
            contact={contact as ExtendedSurveyContact}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default SortableContactList;
